module.exports = __webpack_public_path__ + "static/media/plusSvg.55a12617.svg";